function BreakpointMarker() {
    return (
        <div className="z-[999] absolute top-2 left-2 border border-neutral-400 text-neutral-400 p-2 rounded-xl">
            <p className="sm:hidden">XS</p>
            <p className="hidden sm:block md:hidden">SM</p>
            <p className="hidden md:block lg:hidden">MD</p>
            <p className="hidden lg:block xl:hidden">LG</p>
            <p className="hidden xl:block 2xl:hidden">XL</p>
            <p className="hidden 2xl:block">2XL</p>
        </div>
    )
}

export default BreakpointMarker;